/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from "@mui/material";

import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

// NewProduct page components
import FormField from "layouts/ecommerce/products/edit-product/components/FormField";

function FormFields({
  formValues,
  currentFormValues,
  actionButton,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.only("sm"));

  const [formDataValues, setFormDataValues] = useState({
    reservationId: ""
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "numberOfTickets") {
      if (value < 0) return;
      else if (value > 25) return;

      const newFormDataValues = {
        ...formDataValues,
        [name]: value,
        sumOfPrice: parseFloat(formDataValues.selectedCategoryPrice) * parseInt(value),
      };
      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
    } else {
      const newFormDataValues = {
        ...formDataValues,
        [name]: value,
      };
      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
    }
  };

  useEffect(() => {
    if (currentFormValues && currentFormValues.formInfo) {
      setFormDataValues({
        reservationId: currentFormValues.formInfo.reservationId || ""
      });
    } else {
      setFormDataValues({
        reservationId: ""
      });
    }
  }, [currentFormValues]);

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5">Information</MDTypography>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            {/* Réference de résérvation */}
            <Grid item xs={12}>
              <FormField
                type="text"
                label="id de résérvation"
                name="reservationId"
                value={formDataValues?.reservationId}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <MDBox mt={4} ml={4}>
        {actionButton}
      </MDBox>
    </Card>
  );
}

FormFields.propTypes = {
  formValues: PropTypes.func.isRequired,
  selectedPlaceEvent: PropTypes.func.isRequired,
  currentFormValues: PropTypes.object.isRequired,
  eventData: PropTypes.array.isRequired,
  actionButton: PropTypes.node.isRequired,
};

export default FormFields;
